export var ADD_GROUP = '@group_by/ADD_GROUP';
export var SELECT_GROUP_PROPERTY = '@group_by/SELECT_GROUP_PROPERTY';
export var REMOVE_GROUP = '@group_by/REMOVE_GROUP';
export var RESET_GROUPS = '@group_by/RESET_GROUPS';
export var SET_GROUPS = '@group_by/SET_GROUPS';
export var DRAG_ANIMATION_TIME = 100;